import { render, staticRenderFns } from "./StatusDot.vue?vue&type=template&id=baf8fb78&scoped=true"
import script from "./StatusDot.vue?vue&type=script&lang=js"
export * from "./StatusDot.vue?vue&type=script&lang=js"
import style0 from "./StatusDot.vue?vue&type=style&index=0&id=baf8fb78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf8fb78",
  null
  
)

export default component.exports